__turbopack_context__.v({
  "turn": "rotating-word-module__NfPIRW__turn",
  "word": "rotating-word-module__NfPIRW__word",
});
